import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  CallsListPage,
  CallItem,
} from '@karehero/llama/pwa/pages/CallsListPage/CallsListPage';

import {
  DocumentTagID,
  CallStatus,
  OrganiseDocumentStatus,
} from '@karehero/models';
import { formatDayMonthTime } from '@karehero/helpers/datetime';
import { useGoBack } from 'hooks/useGoBack';

import { getCurrentCareCircle } from 'store/slices/careCircleSlice';
import { useListOrganiseDocumentsQuery } from 'store/api/organiseDocument';

import { DYNAMIC_ROUTES, ROUTES } from 'router/routes';

const ADVISOR_NAME = 'Your advisor';

export const CallsList = () => {
  const goBack = useGoBack();
  const navigate = useNavigate();
  const careCircle = useSelector(getCurrentCareCircle);
  const careCircleId = careCircle?.id ?? '';

  const { data: documents = [], isLoading } = useListOrganiseDocumentsQuery(
    { careCircleId, includeTags: [DocumentTagID.CallNotes] },
    { skip: !careCircleId },
  );

  const calls: CallItem[] = useMemo(
    () =>
      documents
        .filter((doc) => doc.status !== OrganiseDocumentStatus.Pending)
        .map((doc) => ({
          id: doc.id,
          title: doc.title,
          when: formatDayMonthTime(doc.createdAt),
          withName: ADVISOR_NAME,
          status: CallStatus.Past,
        })),
    [documents],
  );

  const handleBookCall = () => navigate(ROUTES.BOOK_CALL);

  return (
    <CallsListPage
      calls={calls}
      isLoading={isLoading}
      onBack={goBack}
      onViewCall={(call) => navigate(DYNAMIC_ROUTES.CALL_NOTE_VIEW(call.id))}
      onBookCall={handleBookCall}
    />
  );
};

export default CallsList;
